<template>
  <v-btn
    icon
    large
    @click.stop="ToggleDrawer"
    class="fontos-icon drawer-controller"
  >
    <i class="fas fa-bars primary--text"></i>
  </v-btn>
</template>

<script>
import { AppStoreTypes } from '../../store/modules/app';
export default {
  name: 'k-hamburger-icon',
  data() {
    return {};
  },
  methods: {
    ToggleDrawer() {
      this.drawer = !this.drawer;
    },
  },
  computed: {
    drawer: {
      get() {
        return this.$store.getters[AppStoreTypes.isDrawerOpened.get];
      },
      set(value) {
        this.$store.dispatch(AppStoreTypes.isDrawerOpened.set, { value });
      },
    },
  },
};
</script>

<style></style>
